import {Link} from "react-router";
import {DiscoverClubHouseTeamResponse} from "libs/apiClient";

export function ClubhouseTeamsTable({
	teams
}: {
	teams: DiscoverClubHouseTeamResponse[]
}) {
	if (teams.length === 0) {
		return <div className="empty-sub-table">No teams</div>
	}

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>Team ID</th>
					<th>Name</th>
					<th>Was invited to the clubhouse</th>
				</tr>
			</thead>
			<tbody>
				{teams.map((team: DiscoverClubHouseTeamResponse, index) => (
					<tr key={`row-${index}`}>
						<td>{team.id}</td>
						<td>
							<Link to={`/discover/team/${team.id}`}><strong>{team.name}</strong></Link>
						</td>
						<td>
							{team.invited !== null && (team.invited ? 'Yes' : 'No')}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
